export const hasPermission = (moduleName, action = "View") => {
  const token = localStorage.getItem("dcms_token");
  if (!token) return false;

  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
    
    const decoded = JSON.parse(jsonPayload);
    const role = decoded["role"] || decoded["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"];
    if (role === "Administrator") return true; // Administrator has full access override
  } catch (e) {
    // Ignore decoding errors
  }

  const userJson = localStorage.getItem("dcms_user");
  if (!userJson) return false;

  try {
    const user = JSON.parse(userJson);
    const permissions = user.permissions || [];
    const key = `${moduleName.replace(/\s+/g, "")}:${action}`;
    return permissions.includes(key);
  } catch (e) {
    return false;
  }
};
